"use client";

import { useLocaleCtx } from "@/contexts/locale";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export function SwitchLang() {
  const { inactiveLang, isChangingLang, hide, onLangChange } = useLocaleCtx();

  return (
    <Button
      size={"icon"}
      variant={"outline"}
      className={cn(
        "my-auto flex h-[2.75rem] w-[2.75rem] items-center justify-center rounded-full border-2 border-[#F3D5A9]/30 bg-transparent !p-0 text-sm leading-none transition-all duration-150 ease-in hover:scale-105 sm:h-[3.75rem] sm:w-[3.75rem] sm:text-xl ltr:!pb-1 ltr:sm:!pb-2",
        isChangingLang ? "cursor-wait" : "",
        hide ? "invisible" : ""
      )}
      // isLoading={isChangingLang}
      disabled={isChangingLang || hide}
      onClick={onLangChange}
    >
      {inactiveLang}
    </Button>
  );
}
